import { ApaduaAPI } from './ApaduaAPI';

export class SalutationsAPI extends ApaduaAPI {
    resource: string = 'api/salutations/';

    getSalutations(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
